var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCn = function SvgCn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21787_20855",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21787_20855)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#E0352F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0115 6.76722L10.5461 6.48298L10.441 5.88672L10.8765 6.3073L11.4111 6.02306L11.1457 6.56724L11.5812 6.98782L10.9817 6.90356L10.7162 7.44773L10.6111 6.85148L10.0115 6.76722Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9154 8.20703L11.1025 8.78285H11.7079L11.2181 9.13873L11.4052 9.71455L10.9154 9.35867L10.4255 9.71455L10.6126 9.13873L10.1228 8.78285H10.7283L10.9154 8.20703Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.78906L5.06129 6.51652H6.87764L5.40818 7.58415L5.96946 9.3116L4.5 8.24398L3.03054 9.3116L3.59182 7.58415L2.12236 6.51652H3.93871L4.5 4.78906Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.875 4.83333L9.29918 5.02043V5.62588L8.94331 5.13606L8.36749 5.32315L8.72336 4.83333L8.36749 4.34351L8.94331 4.53061L9.29918 4.04079V4.64624L9.875 4.83333Z",
    fill: "#FED43E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.875 10.9036L9.29918 11.0907V11.6962L8.94331 11.2064L8.36749 11.3935L8.72336 10.9036L8.36749 10.4138L8.94331 10.6009L9.29918 10.1111V10.7166L9.875 10.9036Z",
    fill: "#FED43E"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cn.bc59295eb98a8d8a0af50ebf306ffb59.svg";